var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/~/lodash/_mapCacheHas.js
 ** module id = 1097
 ** module chunks = 0
 **/